/**
 * 數學科圖片 / 資源 URL 集中管理。
 *
 * 用法:
 *  1. 換域名或整個資料夾路徑 -> 只改下面 BASE。
 *  2. 加新圖片 -> 在 mathsImg 加一行,然後喺該頁 block 用 mathsImg.xxx。
 *  3. 唔想加 key 都可以直接喺 block 寫 `${BASE}/development/new.jpg`,兩種都得。
 */

const BASE = "https://www.pkps.edu.hk/img/teachplan/maths";
const BASE_HTTPS = "https://www.pkps.edu.hk/img/teachplan/maths";
const LEGACY = "https://www.pkps.edu.hk/09-10%20teachplan/final/images/MS";
const LEGACY_PDF = "https://www.pkps.edu.hk/09-10%20teachplan/final";

export const mathsPaths = { BASE, BASE_HTTPS, LEGACY, LEGACY_PDF };

export const mathsImg = {
    // 課程目標
    objectivesTop: `${BASE}/objectives/top.jpg`,
    objectivesObj1: `${BASE}/objectives/obj1.jpg`,
    objectivesObj2: `${BASE}/objectives/obj2.jpg`,
    objectivesObj3: `${BASE}/objectives/obj3.jpg`,
    objectivesObj4: `${BASE}/objectives/obj4_2627.jpg`,

    // 校本課程特色
    baseTop: `${BASE}/base/top.jpg`,
    base1: `${BASE}/base/base1.jpg`,
    baseChart: `${BASE}/base/base_chart.jpg`,
    base2: `${BASE}/base/base2.jpg`,
    base3: `${BASE}/base/base3.jpg`,

    // 年度重點項目
    concernTop: `${BASE_HTTPS}/concern/top.jpg`,
    concern2526_1: `${BASE_HTTPS}/concern/2526-1.png`,
    concern2526_2: `${BASE_HTTPS}/concern/2526-2.png`,
    concern2526_3: `${BASE_HTTPS}/concern/2526-3.jpg`,
    concern2526_4: `${BASE_HTTPS}/concern/2526-4.jpg`,
    concern2425_2: `${BASE_HTTPS}/concern/2425-2.jpg`,
    concern2526_6: `${BASE_HTTPS}/concern/2526-6.png`,
    concern2526_7: `${BASE_HTTPS}/concern/2526-7.jpg`,
    concern2526_8: `${BASE_HTTPS}/concern/2526-8.png`,
    concern2526_9: `${BASE_HTTPS}/concern/2526-9.png`,
    concern2526_10: `${BASE_HTTPS}/concern/2526-10.jpg`,
    concern2627_1: `${BASE_HTTPS}/concern/2627_1.png`,
    concern2627_2: `${BASE_HTTPS}/concern/2627_2.jpg`,
    concern2627_3: `${BASE_HTTPS}/concern/2627_3.jpg`,
    concern2627_4: `${BASE_HTTPS}/concern/2627_4.jpg`,  
    concern2627_5: `${BASE_HTTPS}/concern/2627_5.jpg`, 
    concern2627_6: `${BASE_HTTPS}/concern/2627_6.png`,

    // 學生成果展示
    displayTop:
        "https://lh3.googleusercontent.com/pw/AL9nZEVYyUur0A26DVgmKJ7M-U-rLJ5NojzGOQHU3KJtIQbUcW4ZJb-ihr8QQX9eUnb2YztLnGDasTj926dSs1JYsVaL4mpFMgN3_7X7kZpNBnXVHtmHC5UGs0vKJC-bGvpRVxMpBA-F01RZ0LL4vxW09hSn=w1920-h792-no?authuser=0",
    displayIcon01: `${BASE}/display/icon01a.jpg`,
    displayIcon02: `${BASE}/display/icon02.jpg`,
    displayIcon03: `${BASE}/display/icon03.jpg`,
    displayIcon04: `${BASE}/display/icon04.jpg`,
    displayIcon05: `${BASE}/display/icon05.jpg`,
    displayIcon06: `${BASE}/display/icon06.jpg`,
    displayIcon07: `${BASE}/display/icon07.jpg`,
    display2a: `${BASE}/display/2a.jpg`,
    display2b: `${BASE}/display/2b.jpg`,
    display2c: `${BASE}/display/2c.jpg`,
    display3a: `${BASE}/display/3a.jpg`,
    display3b: `${BASE}/display/3b.jpg`,
    display0a: `${BASE}/display/0a.jpg`,
    display0b: `${BASE}/display/0b.jpg`,
    display1: `${BASE}/display/1.jpg`,
    displayLegacy14: `${LEGACY}/MS04-14.jpg`,
    displayLegacy15: `${LEGACY}/MS04-15.jpg`,
    displayLegacy04: `${LEGACY}/MS04-04.jpg`,
    displayLegacy05: `${LEGACY}/MS04-05.jpg`,
    displayLegacy08: `${LEGACY}/MS04-08.jpg`,
    displayLegacy16: `${LEGACY}/MS04-16.jpg`,

    // 教師專業發展
    developmentTop: `${BASE}/development/top.jpg`,
    development2526_1: `${BASE}/development/2526-1.jpg`,
    development1: `${BASE}/development/development1.jpg`,
    development2: `${BASE}/development/development2.jpg`,
    development3: `${BASE}/development/development3.jpg`,
    development0a: `${BASE}/development/0a.jpg`,
    development0b: `${BASE}/development/0b.jpg`,
    development2526_2: `${BASE}/development/2526-2.png`,
    development2627_1: `${BASE}/development/2627-1.jpg`,
    development2627_2: `${BASE}/development/2627-2.jpg`,
    development2627_3: `${BASE}/development/2627-3.jpg`,
    developmentImg1: `${BASE}/development/1.jpg`,
    developmentImg2: `${BASE}/development/2.jpg`,
    development4: `${BASE}/development/development4.jpg`,
    development5: `${BASE}/development/development5.jpg`,
    development6: `${BASE}/development/development6.jpg`,
    development7: `${BASE}/development/development7.jpg`,
    development8a: `${BASE}/development/development8a.jpg`,
    development8b: `${BASE}/development/development8b.jpg`,
    development8c: `${BASE}/development/development8c.jpg`,
    development9: `${BASE}/development/9.jpg`,
    development9b: `${BASE}/development/development9.jpg`,
    development10: `${BASE}/development/development10.jpg`,

    // 網上學習資源
    resourcesTop: `${BASE}/resources/top.jpg`,
    resources1: `${BASE}/resources/res1.jpg`,
    resources2: `${BASE}/resources/res2.jpg`,
    resources3: `${BASE}/resources/res3.jpg`,
};
